import { isEmpty, isEqual, isFunction } from "@util/utils";
import React, { useImperativeHandle, useMemo, useState } from "react";
import { MenuItem, SelectField, Typography } from "@curves/ui-base";

const DiscountPlanSelect = React.forwardRef((props, ref) => {
	const { options = [], getRangeFeeApi, onChange: onChangeProps, label = "優惠折扣", required = true, ...restProps } = props;
	const [internalValue, setInternalValue] = useState(0);
	const [showRequiredError, setShowRequiredError] = useState(false);

	const handleChange = (_, { props }) => {
		const value = props.value;
		if (isEqual(internalValue, value)) return;
		setInternalValue(value);
		setShowRequiredError(false);
		isFunction(onChangeProps) && onChangeProps(value);

		if (isEqual(value, 0)) {
			getRangeFeeApi(0, 0);
			return;
		}
		const planType = options.find(item => isEqual(item.planID, value)).planType;
		getRangeFeeApi(value, planType);
	};

	const itemMemo = useMemo(
		() => {
			return (
				Array.isArray(options) &&
				options.map(item => (
					<MenuItem key={item.planID} value={item.planID}>
						{item.planName}
					</MenuItem>
				))
			);
		},
		// eslint-disable-next-line
		[options]
	);

	useImperativeHandle(
		ref,
		() => ({
			getResult: () => {
				const planID = internalValue;
				const planType = options.find(item => isEqual(item.planID, internalValue))?.planType ?? 0;
				return { planID, planType };
			},
			isError: () => {
				if (!required) {
					setShowRequiredError(false);
					return false;
				}
				const invalid = isEqual(internalValue, 0);
				setShowRequiredError(invalid);
				return invalid;
			},
		}),
		// eslint-disable-next-line
		[internalValue, options, required]
	);

	return (
		<React.Fragment>
			<SelectField
				label={label}
				value={internalValue}
				onChange={handleChange}
				displayEmpty
				fullWidth
				{...restProps}
				required={required}
				isError={showRequiredError}
			>
				<MenuItem value={0} disabled>
					<em>請選擇</em>
				</MenuItem>
				{itemMemo}
			</SelectField>
			{!isEmpty(options) && (
				<Typography className={"text-info smart-fitness-band-plan-description"}>{options.find(item => isEqual(item.planID, internalValue))?.planDescription}</Typography>
			)}
		</React.Fragment>
	);
});

export default DiscountPlanSelect;
